import clsx from "clsx";
import { memo } from "react";
import "./StatusCell.scss";

export interface StatusDisplay {
  label: string;
  color: string;
  bgcolor: string;
}

export type StatusTransMap<T extends string> = Record<T, StatusDisplay>;

export type StatusCellProps<T extends string> = {
  value?: T | null;
  trans: StatusTransMap<T>;
  className?: string;
};

function StatusCellComponent<T extends string>({
  value,
  trans,
  className,
}: StatusCellProps<T>) {
  if (!value) {
    return null;
  }

  const config = trans[value];

  if (!config) {
    return null;
  }

  return (
    <span
      className={clsx("tableStatusCell", className)}
      style={{
        color: config.color,
        backgroundColor: config.bgcolor,
      }}
    >
      {config.label}
    </span>
  );
}

export const StatusCell = memo(StatusCellComponent) as typeof StatusCellComponent;

StatusCellComponent.displayName = "StatusCell";
